import { render, staticRenderFns } from "./AfterSalesPrint.vue?vue&type=template&id=3270d6fb&scoped=true&"
import script from "./AfterSalesPrint.vue?vue&type=script&lang=js&"
export * from "./AfterSalesPrint.vue?vue&type=script&lang=js&"
import style0 from "./AfterSalesPrint.vue?vue&type=style&index=0&id=3270d6fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3270d6fb",
  null
  
)

export default component.exports